import React, { Component } from 'react';
import AudioJoinerWorkFinishRender from './children/AudioJoinerWorkFinishRender';
import Utils from '@/utils';
import '@/assets/audioJoiner.less';
import sentGAEvent from '@/ga';
class AudioJoinerWorkFinishFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleDownload = () => {
    Utils.downloadFile(this.props.audioJoinerAfter, this.props.format);
    sentGAEvent({
      category: 'DownloadStart',
      action: '27AM_DownloadStart',
    });
  };
  render() {
    return (
      <AudioJoinerWorkFinishRender
        status={this.props.status}
        audioJoinerAfter={this.props.audioJoinerAfter}
        handleDownload={this.handleDownload}
        handleSubmitAgain={this.props.handleSubmitAgain}
      />
    );
  }
}

export default AudioJoinerWorkFinishFunction;
